import { useMutation, useQuery } from '@tanstack/react-query';
import { IDictionary } from '../../Interfaces/IDictionary';
import { customFetcher } from '../useFetch';

export const useGetDictionaries = () => {
  const {
    data: dictionaries,
    isLoading: isLoadingDictionaries,
    refetch: refetchDictionaries,
  } = useQuery<IDictionary[]>({
    queryKey: ['dictionary'],
    queryFn: () => customFetcher({ endpoint: '/dictionary' }),
  });

  return { dictionaries, isLoadingDictionaries, refetchDictionaries };
};

export const useWriteDictionary = () => {
  const { mutateAsync: writeDictionary, isPending: isPendingDictionary } =
    useMutation({
      mutationFn: (uploadObject: IDictionary) =>
        customFetcher({
          endpoint: '/dictionary',
          body: uploadObject,
          method: uploadObject.idDictionary < 0 ? 'POST' : 'PUT',
        }),
    });
  return {
    writeDictionary,
    isPendingDictionary,
  };
};
